import { MealType } from "."

export type ScheduleType = "DAILY" | "WEEKLY" | "CUSTOM"
export type ScheduleDayOfWeekType =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY"

export interface IScheduleConfig {
  type: ScheduleType
  startDate: string
  endDate?: string
  daysOfWeek: ScheduleDayOfWeekType[]
}

export interface ISchedule extends IScheduleConfig {
  id: string
  meal: MealType
}

export enum ScheduleBackPage {
  MY_SCHEDULE = "my-schedule",
  DIARY = "diary",
}

export interface ISchedule extends IScheduleConfig {
  id: string
  meal: MealType
}
